// Import console config first before any other code runs
import "./utils/consoleConfig";
import React from "react";
import ReactDOM from "react-dom";
import "./assets/scss/index.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import GA4React from "ga-4-react";
import { createBrowserHistory } from "history";
import { initializeSignOzTracing } from "@echoteam/signoz-react";
import { setupGlobalErrorHandler } from "./utils/errorHandler";
import { setupThirdPartyErrorFilter } from "./utils/thirdPartyErrorFilter";
import { shouldIgnoreError } from "./config/signozConfig";
import { setupErrorTracking } from "./services/tracing";

const history = createBrowserHistory();

// Setup third-party error filter FIRST (sebelum yang lain)
setupThirdPartyErrorFilter();

// Setup global error handler untuk filter error
setupGlobalErrorHandler();

// Signoz dengan custom configuration
try {
  // Library hanya dipakai untuk provider + exporter. Semua logging bawaannya
  // dimatikan karena mencatat body request/respons (password, data pribadi) dan
  // URL halaman lengkap (token reset password). Opsi body WAJIB diisi false di
  // sini: library membaca env-nya sebagai `=== "true" || true` (selalu aktif).
  // Request API dan error dicatat oleh src/services/tracing.js.
  // serviceVersion, environment, serviceNamespace dibaca library dari
  // REACT_APP_SIGNOZ_*; bila salah satu kosong, tracing nonaktif.
  initializeSignOzTracing({
    serviceName: process.env.REACT_APP_SIGNOZ_SERVICE_NAME || process.env.REACT_APP_SERVICE_NAME || "caready-customer-web",
    url: process.env.REACT_APP_SIGNOZ_URL,
    enableRequestLogging: false,
    logRequestBody: false,
    logResponseBody: false,
    enableErrorTracking: false,
    enableNavigationTracking: false,
    enableWebSocketLogging: false,
    logWebSocketMessages: false,
  });
  setupErrorTracking();
} catch (error) {
  console.warn("⚠️ Signoz initialization failed:", error);
}

// Menangani unhandled promise rejections secara global dengan filter
window.addEventListener("unhandledrejection", function (event) {
  const reason = event.reason;

  // Filter error yang tidak perlu di-trace
  if (shouldIgnoreError(reason)) {
    event.preventDefault();
    console.warn("⚠️ Filtered Promise Rejection:", reason);
    return;
  }

  // Mencegah error default browser untuk error yang di-filter
  if (reason && (reason.message?.includes("timeout") || reason.message?.includes("Network Error"))) {
    event.preventDefault();
    console.warn("⚠️ Network/Timeout Error (Filtered):", reason);
    return;
  }

  console.warn("Unhandled promise rejection:", reason);
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

if (process.env.REACT_APP_GA_ID) {
  try {
    setTimeout((_) => {
      const ga4react = new GA4React(process.env.REACT_APP_GA_ID);
      ga4react.initialize().catch((err) => console.error(err));
    }, 40000);
  } catch (err) {
    console.error(err);
  }
  // console.log('env ada')
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export { history };
